import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { TableSort } from 'components/WrappedComponents/Table/types';
import { useExportDashboard } from 'hooks/dossiers/useExportDashboard';
import { useUserStore } from 'hooks/UserStoreContext';

interface DownloadButtonProps<SortType extends string | undefined> {
  readonly filters: Partial<unknown>;
  readonly sort: TableSort<SortType>;
}

function DownloadButton<SortType extends string | undefined>({
  filters: _,
  sort,
}: DownloadButtonProps<SortType>): React.ReactElement {
  const { exportDashboard, inProgress } = useExportDashboard();
  const user = useUserStore();

  return (
    <AntdButton
      icon={<DownloadOutlined />}
      type={'default'}
      shape={'round'}
      onClick={() => {
        exportDashboard(sort, {
          idJuridiction: user.idCorrelationJuridiction ?? undefined,
          // NOSONAR TODO MINTF-6020 : Ajouter les autres filtres.
        });
      }}
      loading={inProgress}
    />
  );
}

export default DownloadButton;
